import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import {
  FormInputTypes,
  getUpdateInputValueFunction,
  GridColSpan,
  TypedFormInputs,
} from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { toggleBorderClasses } from 'containers/jobsiteConfiguration/helpers/utils';
import { Jobsite } from './types';

export const LEGACY_CUTOVER_MESSAGE =
  'This site was permanently migrated to the Avigilon Alta connector. ' +
  'Legacy sync cannot be turned back on. Manage syncing in Connectors.';

export const hasCompletedAvigilonCutover = (
  connector:
    | {
        connectedAt?: string | null;
      }
    | undefined,
  avigilonEnabled: boolean,
): boolean => connector?.connectedAt != null && avigilonEnabled === false;

export const getAvigilonSectionInputs = (
  hasCompletedCutover = false,
): TypedFormInputs<EditJobsiteConfigurationFormData['avigilon']> => ({
  avigilonEnabled: {
    element: FormInputTypes.Toggle,
    label: 'Avigilon Access Control on site (legacy)',
    isHidden: true,
    layout: [GridColSpan.SpanFull, toggleBorderClasses],
    elementProps: {
      disabled: hasCompletedCutover,
      toggleAlignment: 'right-with-space',
      toggleDescription: hasCompletedCutover
        ? LEGACY_CUTOVER_MESSAGE
        : undefined,
    },
  },
  avigilonCameraEnabled: {
    element: FormInputTypes.Toggle,
    label: 'Avigilon cameras on site',
    layout: [GridColSpan.SpanFull, toggleBorderClasses],
    elementProps: { toggleAlignment: 'right-with-space' },
  },
});

export const getAvigilonSectionDefaultValues = (
  jobsite: Jobsite,
  hasCompletedCutover = false,
): EditJobsiteConfigurationFormData['avigilon'] => {
  const { avigilonEnabled = false, avigilonCameraEnabled = false } =
    jobsite ?? {};

  return {
    avigilonEnabled: hasCompletedCutover ? false : avigilonEnabled,
    avigilonCameraEnabled,
  };
};

type AvigilonSectionUpdateInput = Required<
  Pick<JobsiteUpdateInput, 'avigilonEnabled' | 'avigilonCameraEnabled'>
>;

export const getAvigilonSectionUpdateInput = (
  avigilonData: EditJobsiteConfigurationFormData['avigilon'],
  dirtyFields: DeepMap<EditJobsiteConfigurationFormData['avigilon'], true>,
  hasCompletedCutover = false,
): Partial<AvigilonSectionUpdateInput> => {
  const getUpdateInputValue = getUpdateInputValueFunction(
    avigilonData,
    dirtyFields,
  );
  return {
    avigilonEnabled: hasCompletedCutover
      ? undefined
      : getUpdateInputValue('avigilonEnabled'),
    avigilonCameraEnabled: getUpdateInputValue('avigilonCameraEnabled'),
  };
};
